import http from '../../common/Http';


/**
 * 获取首页列表
 * @param service
 * @param page
 * @param pageSize
 * @returns {Promise<any>}
 */
function getProjectList(service = undefined,page = 1,pageSize = 10){
    let url = '/v1/project/' + service;
    return http("get",url,{
        page: page,
        pageSize: pageSize,
    });
}


/**
 * 创建项目
 * @param params
 * @returns {Promise<any>}
 */
function createProject(params) {
    let service = params.service;
    let url = '/v1/project/' + service;
    return http("post",url,params);
}


export {
    getProjectList,
    createProject
}

